import React from "react";
import { Space, Tabs, Typography } from "antd";
import type { TabsProps } from "antd";
import {
  DownloadOutlined,
  SwapOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { AUTH_USER } from "../../../store/selectors";
import Descargas from "./Descargas";
import { isEmmiStaff } from "./emmiStaff";
import Subidas from "./Subidas";

const { Title, Paragraph } = Typography;

const HubContenido: React.FC = () => {
  const user = useSelector(AUTH_USER);

  const tabs: NonNullable<TabsProps["items"]> = [
    {
      key: "subidas",
      label: "Subidas",
      icon: <UploadOutlined />,
      children: <Subidas />,
    },
  ];
  if (isEmmiStaff(user?.email)) {
    tabs.push({
      key: "descargas",
      label: "Descargas",
      icon: <DownloadOutlined />,
      children: <Descargas />,
    });
  }

  return (
    <div style={{ maxWidth: 1400, margin: "0 auto", padding: "24px 16px" }}>
      <Space align="center" style={{ marginBottom: 8 }}>
        <SwapOutlined
          rotate={90}
          style={{ fontSize: 28, color: "var(--bo-primary)" }}
        />
        <Title level={2} style={{ margin: 0 }}>
          HUB contenido
        </Title>
      </Space>
      <Paragraph type="secondary" style={{ marginBottom: 16 }}>
        Sube a plataforma las ODs y quizzes de un tracker, o descarga lo que hay
        hoy en plataforma.
      </Paragraph>
      <Tabs defaultActiveKey="subidas" items={tabs} />
    </div>
  );
};

export default HubContenido;
